import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SmartTableComponent } from './smart-table.component';
import { SmartTableColumnDirective } from './smart-table-column.directive';
import { SmartTableSortComponent } from './smart-table-sort/smart-table-sort.component';
import {IconsModule} from "../../components/icons/icons.module";
import { SmartTableNavigateDirective } from './smart-table-navigate.directive';
import { SmartTableFilterComponent } from './smart-table-filter/smart-table-filter.component';
import {NgSelectModule} from "@ng-select/ng-select";
import {FormsModule} from "@angular/forms";
import {DaterangePickerModule} from "../../components/daterange-picker/daterange-picker.module";
import { SmartTableCollapseDirective } from './smart-table-collapse.directive';
import {RouterModule} from "@angular/router";
import { SmartTableStickyDirective } from './smart-table-sticky.directive';
import { SmartTableCollapseStickyDirective } from './smart-table-collapse-sticky.directive';
import {PerfectScrollbarModule} from "ngx-perfect-scrollbar";
import {FormGroupSelectModule} from '../form-group-context/form-group-select/form-group-select.module';



@NgModule({
  declarations: [
    SmartTableComponent,
    SmartTableColumnDirective,
    SmartTableSortComponent,
    SmartTableNavigateDirective,
    SmartTableFilterComponent,
    SmartTableCollapseDirective,
    SmartTableStickyDirective,
    SmartTableCollapseStickyDirective
  ],
  exports: [
    SmartTableComponent,
    SmartTableColumnDirective,
    SmartTableCollapseDirective
  ],
    imports: [
        CommonModule,
        IconsModule,
        NgSelectModule,
        FormsModule,
        DaterangePickerModule,
        RouterModule,
        PerfectScrollbarModule,
        FormGroupSelectModule
    ]
})
export class SmartTableModule { }
